export const SET_AUTH_USER = 'SET_AUTH_USER';
export const SET_LOADING_SESSION = 'SET_LOADING_SESSION';
